import type { Dataset } from '../../../services/aiConfigService';

export const getFormInitialValues = (editing?: Dataset | null) => {
  if (!editing) return { isActive: true };
  
  // 处理思考方式关联数据（只保留思考方式ID数组）
  const thinkingModes = editing.thinkingModes?.map((tm: any) => {
    // 如果是对象，提取 thinkingModeId
    if (typeof tm === 'object' && tm !== null) {
      return tm.thinkingModeId || tm.thinkingMode?.id || tm.id;
    }
    // 如果已经是字符串，直接返回
    return tm;
  }).filter(Boolean) || [];

  return {
    ...editing,
    paramTemplate: editing.paramTemplate
      ? typeof editing.paramTemplate === 'string'
        ? editing.paramTemplate
        : JSON.stringify(editing.paramTemplate, null, 2)
      : '',
    defaultParams: editing.defaultParams
      ? typeof editing.defaultParams === 'string'
        ? editing.defaultParams
        : JSON.stringify(editing.defaultParams, null, 2)
      : '',
    thinkingModes,
  };
};
